import { render, staticRenderFns } from "./stockAssemblyEditor.vue?vue&type=template&id=44bf8eab&"
import script from "./stockAssemblyEditor.vue?vue&type=script&lang=js&"
export * from "./stockAssemblyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports